import { http } from './http_service';

//Get all
export function all(){
    return http().get('/referral-partner/all');
}

//Get list of referral partners with paginate
export function listPage(obj){
    let params = {
        page:obj.page, 
        recordsPerPage:obj.recordsPerPage, 
        q:obj.q, 
        selectedStatus:obj.selectedStatus, 
        sort_direction:obj.sort_direction, 
        sort_field:obj.sort_field
    }
    return http().get(`/referral-partner/list-page`, {
        params:params
    });
}
//Get all active
export function allActive(){
    return http().get('/referral-partner/active');
}
//Get Single
export function single(id){
    return http().get(`/referral-partner/single/${id}`);
}
//Add one
export function add(data){
    return http().post('/referral-partner/add', data)
}
//Update
export function update(id, data){
    return http().post(`/referral-partner/update/${id}`, data)
}
//Get Dropdown list
/**
 * 
 * @param {string} partner_type | a - all the partners | p - parent partners | s - secondary partner
 * @returns 
 */
export function dropdownList(partner_type){
    return http().get(`/referral-partner/dropdown-list/${partner_type}`);
}